package io.eqoty.kryptools.axlsign

class AxlSignDouble : AxlSign() {
    override val curve25519 = Curve25519Double()

}